import { type ReactNode } from 'react';
import { SectionHeader } from '@/components/ui/section-header';
import type { UserRole } from '@/types/auth';
import type { Approacher } from '../types';
import {
  ManyChatField,
  WalletField,
  ActiveToggle,
  ColorField,
} from './approacher-extra-fields';
import { PersonalSection } from './approacher-edit-personal';
import { AccountSection } from './approacher-edit-account';
import { SwapIgTrigger } from './swap-ig-trigger';

export type EditForm = {
  first_name: string;
  last_name: string;
  ig_username: string;
  personal_ig_username: string;
  email: string;
  phone_prefix: string;
  phone_number: string;
  country: string;
  city: string;
  birthdate: string;
  role: UserRole;
  manychat_subscriber_id: string;
  usdc_wallet: string;
  is_active: boolean;
  member_color: string;
};

type Props = {
  f: EditForm;
  set: (k: keyof EditForm, v: string | boolean) => void;
  approacher: Approacher;
  onUpdated?: (() => void) | undefined;
};

type AdvProps = Props;

function AdvancedSection({
  f,
  set,
  approacher,
  onUpdated,
}: AdvProps): ReactNode {
  return (
    <div className="grid grid-cols-2 gap-sm">
      <ManyChatField
        f={f}
        set={set}
        memberId={approacher.id}
        onCleared={onUpdated}
      />
      <WalletField f={f} set={set} />
      <ActiveToggle f={f} set={set} />
      <ColorField
        value={f.member_color}
        onChange={(v) => set('member_color', v)}
      />
    </div>
  );
}

export function ApproacherEditFields(p: Props): ReactNode {
  const setStr = (k: keyof EditForm, v: string): void => p.set(k, v);
  return (
    <div className="space-y-sm">
      <SectionHeader label="Datos personales" />
      <PersonalSection f={p.f} set={setStr} />
      <SectionHeader label="Cuenta" />
      <AccountSection f={p.f} set={setStr} />
      <SwapIgTrigger approacher={p.approacher} onUpdated={p.onUpdated} />
      <SectionHeader label="Avanzado" />
      <AdvancedSection {...p} />
    </div>
  );
}
